import { Fragment } from "react";

import { flexRender, Table } from "@tanstack/react-table";

import { Cell } from "../../Table/Cell";
import { Row } from "../../Table/Row";
import { tstColumnWidth } from "../TSTTable/columnMeta";

interface TSTExpandableRowsProps<T> {
    table: Table<T>;
    renderSubComponent: (row: T) => React.ReactNode;
}

export function TSTExpandableRows<T>({
    table,
    renderSubComponent,
}: TSTExpandableRowsProps<T>) {
    return (
        <tbody>
            {table
                .getRowModel()
                .rows.filter((row) => row.depth === 0)
                .map((row) => (
                    <Fragment key={row.id}>
                        {/* Render the main row if not expanded */}
                        {
                            <Row selected={row.getIsSelected()}>
                                {row.getVisibleCells().map((cell) => (
                                    <Cell
                                        key={cell.id}
                                        sorted={
                                            cell.column.getIsSorted() !== false
                                        }
                                        width={tstColumnWidth(
                                            cell.column,
                                            table
                                        )}
                                    >
                                        {flexRender(
                                            cell.column.columnDef.cell,
                                            cell.getContext()
                                        )}
                                    </Cell>
                                ))}
                            </Row>
                        }

                        {/* Render the sub-component if the row is expanded */}
                        {row.getIsExpanded() && renderSubComponent && (
                            <tr>
                                <td
                                    colSpan={
                                        table.getVisibleFlatColumns().length
                                    }
                                >
                                    <div>
                                        {renderSubComponent(row.original)}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </Fragment>
                ))}
        </tbody>
    );
}
